export default class QueryStringHelper {
  static objectToQuery(object) {
    return Object.keys(object).reduce((acc, key) => {
      if (object[key] === undefined) { return acc; }
      if (acc === '') { return `?${key}=${object[key]}`; }
      return `${acc}&${key}=${object[key]}`;
    }, '');
  }

  // Ref: https://gomakethings.com/how-to-get-the-value-of-a-querystring-with-native-javascript/
  static getValueByKey(field, url = window.location.href) {
    const regExp = new RegExp(`[?&]${field}=([^&#]*)`, 'i');
    const match = regExp.exec(url);

    return match ? match[1] : undefined;
  }

  /**
  * Add a URL parameter (or modify if already exists)
  * Ref: https://stackoverflow.com/questions/486896/adding-a-parameter-to-the-url-with-javascript
  * @param {string} url
  * @param {string} param the key to set
  * @param {string} value
  */
  static addOrReplaceParam(url, param, value) {
    const encodedParam = encodeURIComponent(param);
    const r = `([&?]|&amp;)${encodedParam}\\b(?:=(?:[^&#]*))*`;
    const a = document.createElement('a');
    const regex = new RegExp(r);
    const str = param + (value ? `=${encodeURIComponent(value)}` : '');
    a.href = url;
    const q = a.search.replace(regex, `$1${str}`);
    if (q === a.search) {
      a.search += (a.search ? '&' : '') + str;
    } else {
      a.search = q;
    }
    return a.href;
  }
}



// WEBPACK FOOTER //
// ./src/utils/QueryStringUtil.js